import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NewJobService } from '../app-service/newJob.service';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-confirm-password-dialog',
  templateUrl: './confirm-password-dialog.component.html',
  styleUrls: ['./confirm-password-dialog.component.css']
})
export class ConfirmPasswordDialogComponent implements OnInit {

  constructor(private router: Router,private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { username: any},
    public dialogRef: MatDialogRef<LoginComponent>,private newJobService: NewJobService) { }
    hide = true;
    hideC=true;
    playimg:string="assets/images/eye.png";
  pauseimg:string="assets/images/visible.png";
  stopimg:string="assets/images/stop.png";
  backimg:string="assets/images/back.png";
  closeimg:string="assets/images/close.png";
  ngOnInit(): void {
  }
  OnSubmit(Password:any,C_password:any)
  {
    console.log(Password+"  "+C_password+ this.data.username)
    if(Password===C_password){
    this.newJobService.updatePassword(this.data.username, C_password).subscribe(      
      (result: any) => {
        if (result) {
          // console.log(result);
          if (result.Success) {
            this.snackBar.open('Password Updated Successfully..', '', {
              duration: 3000
            });
            this.dialogRef.close(true);
             this.router.navigate(['/']).then(() => {
             window.location.reload();
             });
          }
          else {
            this.snackBar.open('Password not updated..', '', {
              duration: 3000
            });
          }
        }
      },
      (error: HttpErrorResponse) => {
        //console.log(error);
        this.snackBar.open('Some error occured..', '', {
          duration: 3000
        });
        
      })
    }
    else
    {
      this.snackBar.open('Both passwords should be same','',{
        duration:5000
      });
    }
    
  }
  close()
{
  this.dialogRef.close('')
}  skip()
  {
    // console.log("skip")
    this.dialogRef.close(false);
  }
}
